import { Fade, IconButton, Menu, MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import { exportCanvasAsPNG, exportCSV } from "../../Utility/Utility";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useState } from "react";

const DownloadButton = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadPNG = () => {
    setAnchorEl(null);
    exportCanvasAsPNG(
      props.canvas,
      props.fileName,
      props.isMap,
      props.imageAsset
    );
  };

  const handleDownloadCSV = () => {
    setAnchorEl(null);
    exportCSV(props.csv, props.fileName);
  };

  return (
    <Box display="flex" justifyContent="flex-end">
      {(props.canvas || props.imageAsset) && props.fileName && (
        <Box display="flex">
          <Box sx={{ display: { xs: "none", md: "contents" } }}>
            <p
              className="paragraph"
              style={{
                fontSize: "15px",
                paddingTop: "2px",
                fontFamily: "Roboto Condensed",
              }}
            >
              Download
            </p>
          </Box>
          <Box
            component="span"
            onClick={handleClick}
            sx={{ cursor: "pointer", ml: "5px" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.143"
              height="20"
              viewBox="0 0 17.143 20"
            >
              <g id="download" transform="translate(-4.5 -2.25)">
                <path
                  id="Path_496"
                  data-name="Path 496"
                  d="M21.036,11.536l-1.007-1.007-5.422,5.414V2.25H13.179V15.943L7.757,10.529,6.75,11.536l7.143,7.143Z"
                  transform="translate(-0.821)"
                  fill="#22294d"
                />
                <path
                  id="Path_497"
                  data-name="Path 497"
                  d="M20.214,27v2.857H5.929V27H4.5v2.857a1.429,1.429,0,0,0,1.429,1.429H20.214a1.429,1.429,0,0,0,1.429-1.429V27Z"
                  transform="translate(0 -9.036)"
                  fill="#22294d"
                />
              </g>
            </svg>
          </Box>
        </Box>
      )}
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleDownloadPNG}>Download PNG</MenuItem>
        {props.csv && (
          <MenuItem onClick={handleDownloadCSV}>Download CSV</MenuItem>
        )}
      </Menu>
    </Box>
  );
};

export default DownloadButton;
